import IntegrationType from "../../../../types/integration/IntegrationType";
import NotificationIntegrationList from "../NotificationIntegrationList";
import { NOTIFICATION_INTEGRATIONS } from "../../../../helpers/notificationIntegrations";

function List(props: { loading: number, emailIntegration: IntegrationType[], refresh: Function, isAdmin: boolean }) {
    return (
        <NotificationIntegrationList
            loading={props.loading}
            parameters={props.emailIntegration}
            refresh={props.refresh}
            isAdmin={props.isAdmin}
            config={NOTIFICATION_INTEGRATIONS.email}
            basePath="/admin/integrations/email"
            iconClass="far fa-envelope"
            endpointLabel="SMTP host"
            endpointKey="host"
        />
    );
}

export default List;
